export default __webpack_public_path__ + "static/media/b21506c54f77bc21e2689e81492912ef.svg";